import { render, staticRenderFns } from "./ProductsLayout.vue?vue&type=template&id=d881600c&scoped=true"
import script from "./ProductsLayout.vue?vue&type=script&lang=js"
export * from "./ProductsLayout.vue?vue&type=script&lang=js"
import style0 from "./ProductsLayout.vue?vue&type=style&index=0&id=d881600c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d881600c",
  null
  
)

export default component.exports